export const STAGING_SCAN_SORTATION_CENTERS: string[] = ["SC_ATL_1", "SC_EWR_1", "SC_TST_1"];
